import { Area, AreaChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Bar, BarChart } from "recharts";

const C = ["#047857", "#2563EB", "#D97706", "#DC2626", "#0891B2"];
const tick = (gran) => (v) => {
  const d = new Date(v);
  return gran === "hour" ? d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit" }) : d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
};

export function SeriesChart({ points, x = "ts", lines, gran = "minute", unit = "", height = 220, area, testId }) {
  if (!points?.length) return <div data-testid={testId} className="h-[120px] flex items-center justify-center text-sm text-slate-400">Bu aralıkta kayıtlı ölçüm yok</div>;
  const Chart = area ? AreaChart : LineChart;
  return (
    <div data-testid={testId}>
      <ResponsiveContainer width="100%" height={height}>
        <Chart data={points} margin={{ left: -10, right: 8, top: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey={x} tickFormatter={tick(gran)} stroke="#94a3b8" fontSize={11} minTickGap={30} />
          <YAxis stroke="#94a3b8" fontSize={11} unit={unit} width={56} />
          <Tooltip labelFormatter={(v) => new Date(v).toLocaleString("tr-TR")} formatter={(v) => (v === null ? "veri yok" : `${v}${unit}`)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {lines.map(([key, name], i) => area
            ? <Area key={key} type="monotone" dataKey={key} name={name} stroke={C[i]} fill={C[i]} fillOpacity={0.12} strokeWidth={2} isAnimationActive={false} connectNulls={false} />
            : <Line key={key} type="monotone" dataKey={key} name={name} stroke={C[i]} strokeWidth={2} dot={false} isAnimationActive={false} connectNulls={false} />)}
        </Chart>
      </ResponsiveContainer>
    </div>
  );
}

export function HourBars({ rows, testId }) {
  if (!rows?.length) return <div data-testid={testId} className="h-[120px] flex items-center justify-center text-sm text-slate-400">Henüz saatlik kayıt yok</div>;
  return (
    <div data-testid={testId}>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={rows} margin={{ left: -10, right: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="hour" stroke="#94a3b8" fontSize={11} tickFormatter={(h) => `${String(h).padStart(2, "0")}:00`} />
          <YAxis stroke="#94a3b8" fontSize={11} width={48} />
          <Tooltip labelFormatter={(h) => `${String(h).padStart(2, "0")}:00 (TR)`} />
          <Bar dataKey="avg_requests" name="Ort. istek / saat" fill="#047857" radius={[6, 6, 0, 0]} isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
